module.exports = __webpack_public_path__ + "img/swap.9bee6946.svg";